$(document).ready(function () {
  if ($.cookie("subscribeShowed") === undefined) {
    setTimeout(() => {
      $("#modal-subscribe").modal("show");
      $.cookie("subscribeShowed", true, { expires: 3, path: "/" });
    }, 15000);
  }
});

const subscribe = {
  send: function (buttonHtml) {
    const $button = $(buttonHtml);
    const $form = $button.closest("form");

    if (!formValidate($form)) {
      return;
    }

    buttonLoad($button);

    $.post("index.php?route=rmx/subscribe", $form.serialize())
      .fail(function () {
        responseError();
      })
      .done(function (response) {
        check = responseCheck(response);

        buttonReset($button, check);

        if (check) {
          const $content = $form.closest(".subscribe-content");

          $content
            .find(".subscribe-content__text")
            .html(
              "Вы подписаны.<br/><br/>Проверьте почтовый ящик, туда должно было прийти первое письмо. На всякий случай проверьте папку «спам»"
            );

          $content.find(".subscribe-content__form").remove();

          if ($button.closest(".modal")) {
            setTimeout(() => {
              $("#modal-subscribe").modal("hide");
            }, 10000);
          }
        }
      });
  },
};
